import { useEffect } from "react";
import "../../components/BlogPost.css";

export default function LearnSkillsFaster() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="singlePost">
      <div className="singlePostWrapper">
        <img
          className="singlePostImg"
          src="https://images.unsplash.com/photo-1542299642-a194ad3a7199?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1350&q=80"
          alt=""
        />
        <h1 className="singlePostTitle">Learn Skills Faster</h1>
        <p className="singlePostDesc">
          There are people that seem like they would learn new skills naturally
          without any effort. Whereas others invest much more time and energy in
          learning a skill and still only become mediocre.
          <br />
          <br />
          On the one hand, a large part of this phenomenon can be explained by
          the fact that the former have most often already mastered similar
          movement or thought processes in other skills. So at some point they
          also had to invest time and energy in learning a skill.
          <br />
          <br />
          Fortunately, there are also some insights involved in the process of
          learning skills that i had to learn the hard way and which i have
          compiled into a practical meditation so that you can save yourself the
          time and effort.
          <br />
          <br />
          The realisation came from two observations that highlighted the
          difference in approach between the experienced learner and the
          beginner.
          <br />
          <br />
          First, while the beginner doesn't get something right, he tries again
          and again in very similar ways. The way he tries is usually the
          technique he was advised. Often the pauses between attempts are very
          short and the desperation becomes more and more obvious.
          <br />
          <br />
          In the same situation, the experienced learner tries different
          approaches. Many of the approaches tried make less sense than the
          approach advised to the beginner. The approaches may even deviate
          greatly from a good technique. Longer pauses are made between
          approaches, while the overall situation seems much more playful and
          fun. <br />
          <br />
          Secondly, when the two learners continue their training in the next
          session, the experienced learner has often made great progress right
          from the start and performs better even in the technique that the
          beginner was advised and has trained much more often.
          <br />
          <br />
          However, the assumption that the experienced learner has tried the
          suggested technique less often is a faulty interpretation.
          <br />
          <br />
          The cognitive ability that enabled us to dominate the planet is our
          ability to approximate the future and find solutions to problems that
          may arise. This executive function implemented in our frontal cortex
          is called planning.
          <br />
          <br />
          With planning we are able to visualise 4d models of situations in our
          head and manipulate these visualisation in a solution-oriented way. We
          use this powerful ability subconsciously every day, for example when
          we imagine ourselves talking to our crush or a person we have a
          conflict with.
          <br />
          <br />A{" "}
          <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3119836/">
            study
          </a>{" "}
          conducted by the Stanford Sleep Disorders Clinic even suggests that
          while we sleep we unconsciously continue to learn the skills we have
          previously trained. It therefore seems clear that we unconsciously use
          the ability to plan in our sleep in order to continue the training.
          <br />
          <br />
          The conclusion I have drawn from these observations is that the skill
          that distinguishes the experienced learner from the beginner is the
          ability to use planning in a more conscious way much more frequently.
          <br />
          <br />
          The experienced learner will attempt different strategies of solution
          in order to create a better model of the situation in his prefontal
          cortex. Through practical experience, the approximation of the future
          that he visualises becomes more accurate each time.
          <br /> True progress in skills is then not achieved in practice, but
          through evaluation and planning after the practical session.
          <br />
          <br />
          The despair of the beginner that is caused by the fact that no direct
          progress is made through constant repetition thus stems from the false
          assumption of how learning works.
          <br />
          <br />
          This ability to learn through planning is a skill that can be learned.
          In order to do so, I recommend that you start by going into meditation
          after every practical learning session. In this meditation you try to
          visualize the learning session and manipulate this scene.
          <br />
          <br />
          You will notice that it will be easier and easier for you to create
          these visualizations and the manipulations will become closer and
          closer to reality. If you get better in planing you will be able to
          perform this meditations even between attempts in the practical
          session. Your dreams will become more realistic and your abillity to
          learn new skills will improve.
        </p>
      </div>
    </div>
  );
}
